{
  "PageTitle": "Biblioteca",
  "HubLibraryTooltip": "Los builders consisten en un grupo de temas y los temas consisten en un grupo de secciones",
  "NoBuildersFound": "No se encontraron constructoras",
  "Builders": "Builders",
  "SearchByBuilderName": "Buscar builder por nombre",
  "SortBy": "Organiza por:",
  "Topic": "Tema",
  "Topics": "Temas",
  "Section": "Sección",
  "Sections": "secciones",
  "ExpandAll": "Expandir todo",
  "CollapseAll": "Desplegar todo",
  "Read More": "Leer más",
  "Show Less": "Muestra menos",
  "Introduction": "Introducción",
  "Answer": "Respuesta"
}
